/**
 * Gera o CSV-modelo de importação de contatos.
 *
 * Além das colunas essenciais (name, phone_number, email, labels), inclui UMA
 * COLUNA por campo personalizado de contato da conta (header = attribute_key),
 * para que o usuário já receba a planilha com todos os campos disponíveis e não
 * precise ajustar manualmente. As células dos campos personalizados vêm vazias:
 * a coluna existe para ser preenchida (ClickUp 86ajgczep).
 *
 * A importação (DataImportJob / DataImport::ContactManager) mapeia qualquer
 * coluna não-reservada para custom_attributes pela própria chave, então o
 * round-trip fecha: o que sai no modelo volta como campo personalizado.
 */

export const BASE_IMPORT_HEADERS = ['name', 'phone_number', 'email', 'labels'];

// Linhas de exemplo só para as colunas essenciais (dados fictícios).
const SAMPLE_ROWS = [
  [
    'Maria Silva',
    '+5511900000001',
    'maria.silva@exemplo.com.br',
    'vip;cliente-ouro',
  ],
  ['Joao Souza', '+5511900000002', '', 'lead'],
  ['Ana Oliveira', '+5521900000003', 'ana.oliveira@exemplo.com.br', ''],
];

// Escapa uma célula só quando ela contém o delimitador (vírgula), aspas ou
// quebra de linha. O ';' das etiquetas é dado, não delimitador, e fica solto.
const csvEscape = value => {
  const v = String(value ?? '');
  return /[",\r\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
};

export const buildContactImportSampleCsv = (customKeys = []) => {
  const keys = (customKeys || []).filter(Boolean);
  const headers = [...BASE_IMPORT_HEADERS, ...keys];
  const rows = SAMPLE_ROWS.map(row => [...row, ...keys.map(() => '')]);
  return [headers, ...rows]
    .map(cols => cols.map(csvEscape).join(','))
    .join('\r\n');
};
